var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 77,
    viewBox: "0 0 348 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 344,
    y1: 30,
    x2: 344,
    y2: 47,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 247,
    y1: 30,
    x2: 247,
    y2: 47,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 259,
    y1: 22,
    x2: 259,
    y2: 55,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 271,
    y1: 17,
    x2: 271,
    y2: 60,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 283,
    y1: 4,
    x2: 283,
    y2: 73,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 295,
    y1: 11,
    x2: 295,
    y2: 67,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 234.908,
    y1: 21.0899,
    x2: 234.09,
    y2: 57.0919,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 307,
    y1: 22,
    x2: 307,
    y2: 65,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 186,
    y1: 11,
    x2: 186,
    y2: 67,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 4,
    x2: 320,
    y2: 73,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 198,
    y1: 6,
    x2: 198,
    y2: 67,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 332,
    y1: 17,
    x2: 332,
    y2: 60,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 27,
    x2: 210,
    y2: 51,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 30,
    x2: 4,
    y2: 47,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 136,
    y1: 33,
    x2: 136,
    y2: 45,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 22,
    x2: 16,
    y2: 55,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 17,
    x2: 28,
    y2: 60,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 27,
    x2: 150,
    y2: 50,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 4,
    x2: 40,
    y2: 73,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 4,
    x2: 162,
    y2: 73,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 11,
    x2: 52,
    y2: 67,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 174,
    y1: 17,
    x2: 174,
    y2: 60,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 22,
    x2: 64,
    y2: 65,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 77,
    y1: 4,
    x2: 77,
    y2: 73,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 89,
    y1: 17,
    x2: 89,
    y2: 60,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 101,
    y1: 4,
    x2: 101,
    y2: 73,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 27,
    x2: 113,
    y2: 50,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 124,
    y1: 23,
    x2: 124,
    y2: 54,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 222,
    y1: 25,
    x2: 222,
    y2: 56,
    stroke: "#DBDBDB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListening);
export default __webpack_public_path__ + "static/media/Listening.797e53e85039fbdde9e6005401752a55.svg";
export { ForwardRef as ReactComponent };